const INSTAGRAM_STORY_LIFESPAN_MS = 24 * 60 * 60 * 1000

export const isStoryExpired = (publishedAt: string | null): boolean => {
  if (publishedAt === null) {
    return true
  }

  const publishedAtMs = new Date(publishedAt).getTime()

  if (Number.isNaN(publishedAtMs)) {
    return true
  }

  return Date.now() - publishedAtMs > INSTAGRAM_STORY_LIFESPAN_MS
}
